import { FacultySearchModel } from './faculty-search-model';

export class FacultySearchResponseModel {
    contacts: FacultySearchModel[];
    errors: string[];
}
